import React from 'react'
import { useFont } from '@confer/lib'
import { GridLayoutProps } from './Interfaces'
import styled from 'styled-components'
import { MobileProgressBar } from '@confer/lib'
import { MobileBanner } from './MobileBanner'
import SectionNavigation from './SectionNavigation'

const MobileGridLayout: React.FC<GridLayoutProps> = ({
  settings,
  question,
  currentPercentage,
  isSurveyScrolled,
  children,
  headerAction,
  sectionNavigation,
}) => {
  const { leftBanner, logoSettings, progressBar } = settings
  const fontFamily = useFont()

  const logosProps =
    question.hideLogo && logoSettings
      ? {
          ...logoSettings,
          hide: question.hideLogo,
        }
      : logoSettings

  return (
    <Container
      fontFamily={fontFamily}
      showBackground={question.type === 'welcomePage'}
      bgImage={leftBanner?.contentPath}
    >
      <Header>
        <MobileBanner isVisible={!isSurveyScrolled && !question.hideLogo} logos={logosProps} />
        {sectionNavigation ? (
          <SectionNavigation {...sectionNavigation} mobile presentation="compact" />
        ) : question.section ? (
          <Section colour={question.section.colour}>{question.section.name}</Section>
        ) : undefined}
        {headerAction ? <HeaderAction>{headerAction}</HeaderAction> : undefined}
      </Header>

      {children}
      <MobileProgressBar
        percentage={currentPercentage}
        settings={settings}
        hide={question.type === 'welcomePage' || !progressBar}
        compact={question.type === 'welcomePage' || isSurveyScrolled || question.hideLogo || false}
      />
    </Container>
  )
}

interface ContainerProps {
  fontFamily: string
  backgroundColour?: string
  showBackground?: boolean
  bgImage?: string
}

const Container = styled.div<ContainerProps>`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  margin: 0 auto;
  font-family: ${(props) => props.fontFamily};
  background-image: ${(props) => (props.showBackground ? `url('${props.bgImage}')` : 'none')};
  background-color: ${(props) => props.backgroundColour ?? 'var(--off-light)'};
  background-size: cover;
`

type HeaderProps = React.HTMLAttributes<HTMLDivElement>

const Header = styled.div<HeaderProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: auto;
`

const HeaderAction = styled.div`
  display: flex;
  align-self: flex-end;
  margin: 0.5rem 1rem 0;
`

interface SectionProps {
  colour?: string
}

const Section = styled.div<SectionProps>`
  padding-left: 1rem;
  font-size: 1.1rem;
  // color: ${(props) => props.colour || 'black'};
  // font-weight: 600;
  &::after {
    content: '';
    position: relative;
    width: 100%;
    height: 1.5px;
    left: 0;
    display: block;
    clear: both;
    // background-color: rgba(0, 0, 0, 0.5)
    background-color: ${(props) => props.colour || 'rgba(0, 0, 0, 0.5)'};
  }
`

export default MobileGridLayout
